module.exports = __webpack_public_path__ + "media/images/symbols/arrow-36afad544d783607053d77026dab97fa.svg";